<template>
  <div
    class="list-item add-agreeing flex align-center px-4"
    :class="{'add-agreeing__loading': withLoading}"
    data-qa="add-agreeing"
    @click="open">
    <sIcon
      class="list-item-icon my-auto mr-4"
      :type="options.icon"/>
    <div class="list-item-title text-start h11-links">
      {{ options.labelBtn }}
    </div>
    <DialogTemplateToolkit
      class="add-agreeing"
      :dialog="dialog.show"
      first_btn="Common.Save"
      :loading="isLoading"
      second_btn="Common.Close"
      :title="options.labelBtn"
      @apply="submit"
      @close="close">
      <template #card-text>
        <StageAdditionalAgreementForm
          ref="form"
          :disabled="isLoading"
          :value.sync="formDate"/>
      </template>
    </DialogTemplateToolkit>
  </div>
</template>
<script>
import StageAgreementsApi from '@/api/stageAgreementsApi'
const stageAgreements_api = new StageAgreementsApi()

import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'
import StageAdditionalAgreementForm from 'components/agreement/StageAdditionalAgreementForm.vue'

export default {
  name: 'AddStageAdditionalAgreement',
  data() {
    return {
      formDate: {
        comment: '',
        moveTenderAfterAgreeSucceeded: false,
        isCancelTenderAfterReject: false,
        stages: []
      },
      dialog: {
        show: false,
        loading: false,
      }
    }
  },
  methods: {
    close() {
      this.formDate.comment = ''
      this.formDate.moveTenderAfterAgreeSucceeded = false
      this.formDate.isCancelTenderAfterReject = false
      this.formDate.stages = []
      this.dialog.show = false
      this.added_dialog = false
    },
    submit() {
      this.$refs.form.createRules()
      this.$nextTick(async () => {
        this.$refs.form.$refs.addAgreeingForm.validate(async (valid) => {
          if (!valid) { return }
          this.dialog.loading = true
          const formDate = this.$_.cloneDeep(this.formDate)
          formDate.stages.forEach((stage) => {
            delete stage.disable
            delete stage.editObject
            delete stage.activeStatus
            delete stage.__typename
            stage.agreements = stage.agreements.map(i => ({
              allowDisagree: i.allowDisagree,
              contactId: i.contactId,
              allowAddFilesOnAgree: !!i.allowAddFilesOnAgree,
              editTenderWhileAgree: i.editTenderWhileAgree
            }))
          })
          await stageAgreements_api.startEaseAdditionalAgree({
            tenderId: this.tenderId,
            comment: formDate.comment,
            stages: formDate.stages,
            moveTenderAfterAgreeSucceeded: formDate.moveTenderAfterAgreeSucceeded,
            isCancelTenderAfterReject: formDate.isCancelTenderAfterReject
          })
            .then((result) => {
              if (result) {
                this.$emit('updateAgreements')
                this.dialog.show = false
              }
            })
            .finally(() => {
              this.dialog.loading = false
            })

        })
      })
    },
    async open() {
      if (this.withLoading) {
        return
      }

      setTimeout( () => {
        this.dialog.show = true
      }, 100)

      if (this.mode !== 'add') {
        this.dialog.loading = true
        await stageAgreements_api.additionalAgreeForEdit(this.tenderId)
          .then((result) => {
            if (result) {
              result.stages.forEach((stage) => {
                stage.editObject = null
                stage.disable = stage.activeStatus === 'DONE' || !!stage.agreements?.find(i => i.status === 'SUCCESS' || i.status === 'CANCELED')
                stage.agreements.forEach((contact) => {
                  contact.edit = false
                })
              })
              this.formDate = result
            }
          })
          .finally(() => {
            this.dialog.loading = false
          })
      }
    },
  },
  computed: {
    isLoading() {
      return this.withLoading || this.dialog.loading
    },
    options() {
      return {
        icon: this.mode === 'add' ? 'invite' : 'edit',
        labelBtn: this.mode === 'add' ? this.$t('Tenders.AddAgreeing') : this.$t('Tenders.EditAgreeing'),
        labelSuccess: this.mode === 'add' ? this.$t('Tenders.AdditionalAcceptorsSuccessfullyAdded') : this.$t('Tenders.AdditionalAcceptorsSuccessfullyEddited')
      }
    },
  },
  components: {
    DialogTemplateToolkit,
    StageAdditionalAgreementForm
  },
  props: {
    tenderId: {
      type: Number,
      required: true
    },
    mode: {
      type: String,
      default: 'add',
      validator: function (value) {
        const correct = ['add', 'edit'].indexOf(value) !== -1
        return correct
      },
    },
    withLoading: {
      type: Boolean
    },
  },
}
</script>
<style scoped lang="scss">
.list-item {
  cursor: pointer;
  position: relative;
  min-height: 40px;
  &:hover:not(.add-agreeing__loading) {
    background: var(--color-main-green);
    transition: 0.25s all;
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0.3;
      background-color: var(--v-secondary__green_chosen-darken1);
    }
  }
}
</style>
